import React from 'react';
//images
import Image from '../assets/avatar.jpg';
//icons
import { FaGithub, FaYoutube, FaLinkedin, FaDownload } from 'react-icons/fa';
//type animation
import { TypeAnimation } from 'react-type-animation';
//motion
import { motion } from 'framer-motion';
//variants
import { fadeIn } from '../variants';

import { Link } from 'react-scroll';


import APIEndPoints from '../middleware/APIEndPoints';


const Banner = () => {
  return (
    <section className='min-h-[65vh] lg:min-h-[68vh]  flex items-center mt-12 sm:mt-0' id='home'>
      <div className='container mx-auto pt-4 sm:pt-0'>
        <div className='flex flex-col gap-y-8 lg:flex-row lg:items-center lg:gap-x-12'>
          {/* {text} */}
          <div className='flex-1 text-center font-secondary lg:text-left'>
            <motion.h1
              variants={fadeIn('up', 0.3)}
              initial='hidden'
              whileInView={'show'}
              viewport={{ once: false, amount: 0.7 }}
              className='text-[50px] font-bold leading-[0.8] lg:text-[110px]'>
              Abhijan <span>Basyal</span>
            </motion.h1>
            <motion.div
              variants={fadeIn('up', 0.4)}
              initial='hidden'
              whileInView={'show'}
              viewport={{ once: false, amount: 0.7 }}
              className='mb-6 text-[36px] lg:text-[60px] font-secondary font-semibold uppercase leading-[1]'>
              <span className='text-white mr-4'>I am a</span>
              <TypeAnimation
                sequence={[
                  'Designer', 2000,
                  'Developer', 2000,
                  'Youtuber', 2000,
                  'Gamer', 2000,
                ]}
                speed={50}
                className='text-accent'
                wrapper='span'
                repeat={Infinity}
              />
            </motion.div>
            <motion.p
              variants={fadeIn('up', 0.5)}
              initial='hidden'
              whileInView={'show'}
              viewport={{ once: false, amount: 0.7 }}
              className='mb-8 max-w-lg mx-auto lg:mx-0'>
              I’m dedicated to crafting user-friendly and visually appealing digital experiences.
              With a focus on blending design and development, I’m always pushing the boundaries of what’s possible.
              Let's bring your ideas to life.

            </motion.p>
            <motion.div
              variants={fadeIn('up', 0.6)}
              initial='hidden'
              whileInView={'show'}
              viewport={{ once: false, amount: 0.7 }}
              className='flex max-w-max gap-x-6 items-center mb-12 mx-auto lg:mx-0'>
              <a href={APIEndPoints.downloadCV.url}>

                <button className='btn btn-lg flex items-center gap-x-2  '>
                  <FaDownload /> Download CV
                </button>
              </a>
              <Link to='contact'
                activeClass='active'
                smooth={true}
                spy={true}
                className='text-gradient btn-link cursor-pointer'>
                Contact me
              </Link>
            </motion.div>
            {/* {Socials} */}
            <motion.div
              variants={fadeIn('up', 0.3)}
              initial='hidden'
              whileInView={'show'}
              viewport={{ once: false }}
              className='flex text-[20px] gap-x-6 max-w-max mx-auto lg:mx-0 text-3xl pl-0 sm:pl-4 '>
              <a href='https://www.youtube.com/@wardragon4824' alt="My youtube" className='hover:text-red-500 hover:scale-150 duration-150 ease-in-out'>
                <FaYoutube className='text-2xl text-white' />
              </a>
              <a href='https://github.com/Abhijanbasyal?tab=repositories' alt="My github" className='hover:text-green-700   hover:scale-150 duration-150 ease-in-out'>
                <FaGithub className='text-2xl text-white' />
              </a>
              <a href='https://www.linkedin.com/in/abhijan-basyal-b69a5928a/' alt="My Linked In" className='hover:text-blue-700  hover:scale-150 duration-150 ease-in-out'>
                <FaLinkedin className='text-2xl text-white' />
              </a>
            </motion.div>
          </div>
          {/* {image} */}
          <motion.div
            variants={fadeIn('down', 0.5)}
            initial='hidden'
            whileInView={'show'}
            className='relative hidden lg:flex flex-1 max-w-[320px] lg:max-w-[400px] lg:pb-10'>
            <img src={Image} alt='' className='rounded-full z-10  shadow-white shadow-2xl ' />
            <motion.div
              className='absolute top-0 left-0 w-full h-full rounded-full border-[0.5rem] border-accent  shadow-2xl shadow-indigo-400 '
              animate={{
                scale: [1.1, 1.1, 1.1],
                rotate: [0, 360],
              }}
              transition={{
                duration: 4,
                repeat: Infinity,
                ease: 'linear'
              }}
            />
          </motion.div>
        </div>
      </div>
    </section>
  )
};

export default Banner;